import { useEffect } from 'react'

export const USER_DATA_REFRESH_INTERVAL_MS = 30_000

/**
 * Refresh user data when the browser can see/fetch it again and on a bounded
 * interval while the app remains visible and online.
 */
export const useUserDataRefresh = ({
  enabled,
  refresh,
}: {
  enabled: boolean
  refresh: () => void
}) => {
  useEffect(() => {
    if (!enabled) return

    const refreshWhenActive = () => {
      if (document.visibilityState === 'visible' && navigator.onLine) {
        refresh()
      }
    }
    const refreshInterval = window.setInterval(
      refreshWhenActive,
      USER_DATA_REFRESH_INTERVAL_MS,
    )

    window.addEventListener('online', refresh)
    window.addEventListener('focus', refreshWhenActive)
    document.addEventListener('visibilitychange', refreshWhenActive)
    return () => {
      window.clearInterval(refreshInterval)
      window.removeEventListener('online', refresh)
      window.removeEventListener('focus', refreshWhenActive)
      document.removeEventListener('visibilitychange', refreshWhenActive)
    }
  }, [enabled, refresh])
}
